var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM18.7593 7.94982C18.3216 7.51217 17.612 7.51217 17.1744 7.94982L10.4553 14.6689L7.61311 11.8267C7.17546 11.3891 6.46589 11.3891 6.02824 11.8267C5.59059 12.2644 5.59059 12.974 6.02824 13.4116L9.66285 17.0462C10.1005 17.4839 10.8101 17.4839 11.2477 17.0462L18.7593 9.53469C19.1969 9.09704 19.1969 8.38747 18.7593 7.94982Z",
    fill: "#229F64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIcon);
export default __webpack_public_path__ + "static/media/correct-icon.695056a3cd753ad0c9783d4eb096cbb2.svg";
export { ForwardRef as ReactComponent };